import React, { useEffect, useState } from 'react';
import usePersistedFilters from '../../hooks/usePersistedFilters';
import { MdOutlineHealthAndSafety } from 'react-icons/md';
import { useGetPriceListTypesQuery } from '../../redux/api/modules/managementApi';
import CreatePriceTypeForm from '../../components/his/price-list/CreatePriceTypeForm';
import PriceItemsTypeTable from '../../components/his/price-list/PriceItemsTypeTable';
import CheckPermission from '../../hooks/CheckPermission';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const ReusableModal = React.lazy(() => import('../../shared/ReuseableModal'));

const PriceListTypes = () => {
  const navigate = useNavigate();
  const { hasPermission } = CheckPermission();
  const [selectedItemData, setSelectedItemData] = useState(null);
  const { t, i18n } = useTranslation();
  const [openCreatePriceTypeModal, setOpenCreatePriceTypeModal] = useState(false);
  const { filters: payloadData, setFilters: setPayloadData } = usePersistedFilters(
    'price_list_types',
    { page: 1, per_page: 20, is_show_all: true }
  );

  const {
    data,
    isLoading: queryLoading,
    isFetching: queryFetching,
    refetch
  } = useGetPriceListTypesQuery(payloadData);

  const loading = queryLoading || queryFetching;

  return (
    <div className='w-full h-full'>
      <PriceItemsTypeTable
        refetch={refetch}
        itemsData={data}
        payloadData={payloadData}
        loading={loading}
        selectedItemData={selectedItemData}
        setSelectedItemData={setSelectedItemData}
        setOpenCreatePriceTypeModal={setOpenCreatePriceTypeModal}
        setPayloadData={setPayloadData}
      />
      <ReusableModal
        isVisible={openCreatePriceTypeModal}
        position='top'
        title={selectedItemData ? t('UpdatePriceListType') : t('CreateNewPriceListType')}
        HeaderIcon={MdOutlineHealthAndSafety}
        onClose={() => {
          setOpenCreatePriceTypeModal(false);
          setSelectedItemData(null);
        }}
      >
        <CreatePriceTypeForm
          selectedItemData={selectedItemData}
          setSelectedItemData={setSelectedItemData}
          getPriceTypePayload={payloadData}
          refetch={refetch}
          setOpenCreatePriceTypeModal={setOpenCreatePriceTypeModal}
        />
      </ReusableModal>
    </div>
  );
};

export default PriceListTypes;
